import { Request } from '@/classes/Request.ts'

export const applyDeposit = async (contractRevisionId: number): Promise<void> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/apply_deposit/` + contractRevisionId.toString())
      .then(() => {
        // TODO: Error handling
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  })
}
